export enum Language {
    Ru = 'ru',
    En = 'en',
}
